import type {ParserT} from '@freckle/parser'
import {Parser, record, merge, array, number} from '@freckle/parser'
import type {Word} from '@freckle/educator-entities/ts/ela/word-study/logic/word-study-question-types'
import {parseWord} from '@freckle/educator-entities/ts/ela/word-study/logic/word-study-question-types'
import type {WordStudyQuestionCommonAttrs} from './../models/word-study-question'
import {parseWordStudyQuestionCommonAttrs} from './../models/word-study-question'

export type WordStudyMultipleChoiceQuestionAttrs = WordStudyQuestionCommonAttrs &
  WordStudyMultipleChoiceQuestionExtraAttrs

type WordStudyMultipleChoiceQuestionCorrectAnswer = {
  index: number
}

type WordStudyMultipleChoiceQuestionExtraAttrs = {
  answers: Array<Word>
  correctAnswers: WordStudyMultipleChoiceQuestionCorrectAnswer
}

const parseWordStudyMultipleChoiceQuestionExtraAttrs: ParserT<WordStudyMultipleChoiceQuestionExtraAttrs> =
  record({
    answers: array(parseWord),
    correctAnswers: record({index: number()})
  })

const parseWordStudyMultipleChoiceQuestionAttrs: ParserT<WordStudyMultipleChoiceQuestionAttrs> =
  merge(parseWordStudyMultipleChoiceQuestionExtraAttrs, parseWordStudyQuestionCommonAttrs)

export const parseWordStudyMultipleChoiceQuestion =
  Parser.mkRun<WordStudyMultipleChoiceQuestionAttrs>(parseWordStudyMultipleChoiceQuestionAttrs)
